var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"renderArea",staticClass:"background-render-area relative w-full h-full grid",style:({
  gridTemplateColumns: `${_vm.sectionDimensions.cols[0]}px ${_vm.sectionDimensions.cols[1]}px`,
  gridTemplateRows: `${_vm.sectionDimensions.rows[0]}px ${_vm.sectionDimensions.rows[1]}px ${_vm.sectionDimensions.rows[2]}px`,
  '--dot-grid-spacing': `${_vm.dotGridSpacing}px`,
  '--mask-cutoff-left': `${_vm.maskCutoff.left}px`,
  '--mask-cutoff-right': `${_vm.maskCutoff.right}px`,
  '--mask-cutoff-top': `${_vm.maskCutoff.top}px`,
  '--mask-cutoff-bottom': `${_vm.maskCutoff.bottom}px`
})},[_c('div',{staticClass:"dot-grid top-left",class:{
    'scaling-active': _vm.performanceDirection === 'positive' && _vm.hoveredCategory === 'scaling',
    'winners-active': _vm.performanceDirection === 'negative' && _vm.hoveredCategory === 'winners',
    'all-active': _vm.hoveredCategory === 'all'
  }}),_c('div',{ref:"topRightDotGrid",staticClass:"dot-grid top-right",class:{ 
    'winners-active': _vm.performanceDirection === 'positive' && _vm.hoveredCategory === 'winners',
    'scaling-active': _vm.performanceDirection === 'negative' && _vm.hoveredCategory === 'scaling',
    'all-active': _vm.hoveredCategory === 'all'
  }}),_c('div',{ref:"spaceConstrainer",staticClass:"dot-grid left"}),_c('div',{staticClass:"dot-grid right"}),_c('div',{ref:"bottomLeftDotGrid",staticClass:"dot-grid left",class:{
    'losers-active': _vm.hoveredCategory === 'losers',
    'all-active': _vm.hoveredCategory === 'all'
  }}),_c('div',{staticClass:"dot-grid right",class:{
    'losers-active': _vm.hoveredCategory === 'losers',
    'all-active': _vm.hoveredCategory === 'all'
  }}),_c('svg',{staticClass:"absolute top-0 left-0 w-full h-full",attrs:{"viewBox":`0 0 ${_vm.sectionDimensions.areaWidth} ${_vm.sectionDimensions.areaHeight}`}},_vm._l((_vm.lineDimensions),function(line,index){return _c('line',{key:`scatter-line-${index}`,attrs:{"x1":line.x1,"y1":line.y1,"x2":line.x2,"y2":line.y2,"stroke":"#EBEFF3","stroke-width":"1.5","stroke-linecap":"round"}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }